import { useEffect } from 'react';

/**
 * 모바일 키보드 대응 글로벌 훅
 * - input/textarea 포커스 시 자동 스크롤 (키보드에 가려지지 않도록)
 * - visualViewport resize 이벤트로 키보드 열림/닫힘 감지
 */
export default function useKeyboardScroll() {
  useEffect(() => {
    // input/textarea 포커스 시 살짝 딜레이 후 스크롤
    const handleFocusIn = (e) => {
      const el = e.target;
      if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') {
        // 키보드가 올라오는 시간 대기 후 스크롤
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300);
      }
    };

    // visualViewport resize — 키보드로 뷰포트가 줄어들면 포커스된 요소 재스크롤
    const handleResize = () => {
      const active = document.activeElement;
      if (active && (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA')) {
        setTimeout(() => {
          active.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
    };

    document.addEventListener('focusin', handleFocusIn);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleResize);
    }

    return () => {
      document.removeEventListener('focusin', handleFocusIn);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', handleResize);
      }
    };
  }, []);
}
